import { Theme } from "../core/Theme";

/**
 * @ignore
 */
export class KxyLineTheme extends Theme {
	protected setupDefaultRules() {
		super.setupDefaultRules();
        this.rule("CategoryAxis").setAll({
            startLocation: 0.5,
            endLocation: 0.5
        });
        this.rule("AxisRenderer").setAll({
            minGridDistance: 30,
        });
        this.rule("AxisLabel", ["x"]).setAll({
            centerY: 0,
            location: 0.5,
            multiLocation: 0.5
        });
        this.rule("Grid").setAll({
            location: 0.5
        });
    }
}